import { CareTeamSlaView } from './CareTeamSlaView';
import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { BackButton, useUserInfo } from '@xolv-mybrightlink/common';

type MessageSlaSecondPageProps = {
  onBack: () => void;
  onLater: () => void;
  onAccept: () => void;
};

const MessageSlaSecondPageAction = (props: MessageSlaSecondPageProps) => {
  return (
    <Box sx={{ display: 'flex', width: '100%', fontSize: 16 }}>
      <BackButton size='large' onBackPressed={props.onBack} />
      <Button
        variant={'outlined'}
        disableElevation
        onClick={props.onLater}
        sx={{
          width: '100%',
          borderRadius: 8,
          mx: 8,
          px: 11,
          py: 4,
          fontSize: 'inherit',
        }}
      >
        <FormattedMessage id='action.sla.later' />
      </Button>
      <Button
        variant={'contained'}
        disableElevation
        onClick={props.onAccept}
        sx={{
          width: '100%',
          borderRadius: 8,
          px: 11,
          py: 4,
          fontSize: 'inherit',
        }}
      >
        <FormattedMessage id='action.sla.accept' />
      </Button>
    </Box>
  );
};

export const CareTeamSlaSecondPage = (props: MessageSlaSecondPageProps) => {
  const userInfo = useUserInfo();
  const isEligibleToPilot = userInfo.hasPilotEligibleClient;
  const textPrefix = isEligibleToPilot ? 'provider' : 'ccm';
  return (
    <CareTeamSlaView
      illustration='/public/assets/images/sla-2.svg'
      titleTextId='care-team.sla-2.title'
      descriptionTextIds={[
        `care-team.sla-2.${textPrefix}.description-1`,
        `care-team.sla-2.${textPrefix}.description-2`,
      ]}
      action={<MessageSlaSecondPageAction {...props} />}
    />
  );
};
